import Vue from 'vue';
import { EipOperationConstant, CreateTypeConstant, ServiceCodeConstant} from './Constants';

const EipPopHelper = {};

/**
 * 默认内容居中显示
 * 改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export function operations(caseOps, target, params, type, isSlb) {
	switch (parseInt(caseOps)) {
		// 续费操作
		case EipOperationConstant.RENEW:
			Ajax.get({
				url: '/api/order',
				action: '/submitRenew',
				param: {
					region: params.region,
					resourceId: params.elasticIpId,
					serviceCode: ServiceCodeConstant.CPSEIP
				},
				success: (data) => {
					if (type !== 'detail') {
						target.updateList('refresh');
					}

					window.location.href = `${Vue.prototype.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${data.tmpOrderId}&resourceType=${CreateTypeConstant.CPSEIP}`;
				},
			});
			break;
		// 解绑EIP操作(云物理服务器)
		case EipOperationConstant.UNBIND:
			const h = target.$createElement;
			const param = {
				region: params.region,
				elasticIpId: params.elasticIpId
			};
			let msg = '';
			let tempParams = {}
			let url = ''
			if (params.instanceType === 'cpslb') {
				tempParams = Object.assign(param, {loadBalancerId: params.instanceId,})
				url = '/api/cps/slbs/disassociateElasticIp'
			} else {
				tempParams = Object.assign(param, {instanceId: params.instanceId,})
				url = '/api/cps/disassociateElasticIp'
			}
			if (params.instanceType === 'cps') {
				msg = target.$t('eip.help.confirmToUnbind', [params.elasticIp, params.instanceName])
			} else if (params.instanceType === 'cpslb') {
				msg = target.$t('eip.help.confirmToUnbindSlb', [params.elasticIp, params.instanceName])
			}
			target.$msgbox({
				title: target.$t('eip.text.unbindPublicIp'),
				message: h('p', getClass(), [
					h('span', null, msg),
				]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				Ajax.put(url, tempParams)
					.then(() => {
						if (type === 'list') {
							target.updateList('refresh');
						} else if (type === 'detail') {
							target.refreshEipListData();
						}
					})
					.catch(async (err) => {
						const { response } = err.data;
						try {
							const json = await response.json();
							target.$message.error(json.errmsg);
						} catch (ex) {
							console.log(ex);
						}
					})
					.finally(() => {
					});
			});
			break;
					// 移出共享带宽
		case EipOperationConstant.REMOVESHARED: {
			const h = target.$createElement;
			const param = {
				region: params.region,
				bandwidthPackageId: params.bandwidthPackageId,
				elasticIpId: params.elasticIpId
			};
			target.$msgbox({
				title: target.$t('eip.text.removeShareBandwidth'),
				message:h('div',null, [
					h('div',{
						'class':'i-text'
						},[
						h('div',
								{
										'class': 'tip-warning mb20',
										'style':'line-height: 20px; text-align: left',
										'domProps': {
												innerHTML: target.$t('eip.text.removeShareBandwidthTip', [params.realBandwidth])

										}

								},
						)
						]),
					h('p', getClass(), [
							h('span', null, target.$t('eip.help.confirmToUnshare', [params.elasticIp, params.bandwidthPackageName])),
					])
				]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				Ajax.put('/api/cps/removeBandwidthPackageIp', param)
				.then(() => {
					if (type === 'list') {
						target.updateList('refresh');
					} else if (type === 'detail') {
						target.getServerData();
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
			});
			break;
		}
		case EipOperationConstant.EDITTAG:
			target.currentRow = params;
			target.editTagDialogVisible = true;
			break;
	}
}

export default EipPopHelper;



// WEBPACK FOOTER //
// ./src/common/EipPopHelper.js